// Generated file : do not modify
export enum GraphGridModes
{
  NONE = 0,
  MENSUEL,
  CACHET,
  HEURE
};

import GraphValue from '@/extend/classes/GraphValue';
import GraphRule from '@/extend/classes/GraphRule';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Grilles des graphes
export default class GraphGrid  {
  // Identifiant unique
  public id: number;
  // id graph
  public graphId: number;
  // Contexte
  public contexte: string;
  // Mode rémunération
  public mode: GraphGridModes;
  // Salaires applicables
  public salaires: GraphValue[];
  // Ids des salaires applicables
  public salaireIds: number[];
  // Règles applicables
  public regles: GraphRule[];
  // Ids des régles applicables
  public regleIds: number[];
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.graphId = 0;
    this.contexte = '';
    this.mode = GraphGridModes.NONE;
    this.salaires = [];
    this.salaireIds = [];
    this.regles = [];
    this.regleIds = [];
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: GraphGrid): GraphGrid {
    const newGraphGrid: GraphGrid = new GraphGrid();
    newGraphGrid.id = obj.id;
    newGraphGrid.graphId = obj.graphId;
    newGraphGrid.contexte = obj.contexte;
    newGraphGrid.mode = obj.mode;
    newGraphGrid.salaires = JSON.parse(JSON.stringify(obj.salaires));
    newGraphGrid.salaireIds = JSON.parse(JSON.stringify(obj.salaireIds));
    newGraphGrid.regles = JSON.parse(JSON.stringify(obj.regles));
    newGraphGrid.regleIds = JSON.parse(JSON.stringify(obj.regleIds));
    newGraphGrid.canUpdate = obj.canUpdate;
    newGraphGrid.canDelete = obj.canDelete;
    newGraphGrid.display = obj.display;
    newGraphGrid.notifDefType = obj.notifDefType;
    return newGraphGrid;
  }

  public toJsonGraphGrid (): string {
    const json = {
      graphId: this.graphId,
      contexte: this.contexte,
      mode: this.mode,
      salaires: this.salaires,
      salaireIds: this.salaireIds,
      regles: this.regles,
      regleIds: this.regleIds,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromGraphGrid (obj: GraphGrid): void {
    this.id = obj.id;
    this.graphId = obj.graphId;
    this.contexte = obj.contexte;
    this.mode = obj.mode;
    this.salaires = obj.salaires;
    this.salaireIds = obj.salaireIds;
    this.regles = obj.regles;
    this.regleIds = obj.regleIds;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.notifDefType = obj.notifDefType;
  }

  public compareGraphGrid (value: GraphGrid): boolean {
    return (this.toJsonGraphGrid() == value.toJsonGraphGrid());
  }

  public cloneGraphGrid (): GraphGrid {
    return GraphGrid.fromJson(this);
  }

  // eslint-disable-next-line
  public static getDate(graphGrids: GraphGrid[]) {
  }
}
